export const CHATBOT_MODE = {
  DEFAULT: 'default',
  LARGE: 'large',
  FULL: 'full',
} as const

export type ChatbotMode = typeof CHATBOT_MODE[keyof typeof CHATBOT_MODE]
